import React from 'react';
export function Results({
  config
}) {
  const stats = [{
    percentage: config.stats.reliefPercentage,
    description: 'felt noticeable relief'
  }, {
    percentage: config.stats.adhesionPercentage,
    description: 'said it stayed on all day'
  }, {
    percentage: config.stats.recommendPercentage,
    description: 'would recommend'
  }];
  return <section className="py-12 bg-[#EAF7F3]" data-id="element-311">
      <div className="container mx-auto px-4" data-id="element-312">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-313">
          Results With Receipts
        </h2>
        {/* Simple chart showing pain reduction */}
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8 max-w-2xl mx-auto" data-id="element-314">
          <div className="h-48 relative mb-2" data-id="element-315">
            <div className="absolute inset-0 flex items-end" data-id="element-316">
              <div className="w-1/4 h-[90%] bg-red-200 mx-1" data-id="element-317"></div>
              <div className="w-1/4 h-[70%] bg-orange-200 mx-1" data-id="element-318"></div>
              <div className="w-1/4 h-[40%] bg-yellow-200 mx-1" data-id="element-319"></div>
              <div className="w-1/4 h-[20%] bg-green-200 mx-1" data-id="element-320"></div>
            </div>
            <div className="absolute inset-0 flex items-end pointer-events-none" data-id="element-321">
              <div className="w-full border-b border-gray-300 absolute bottom-0 left-0" data-id="element-322"></div>
              <div className="w-full border-b border-gray-300 absolute bottom-1/3 left-0" data-id="element-323"></div>
              <div className="w-full border-b border-gray-300 absolute bottom-2/3 left-0" data-id="element-324"></div>
            </div>
            <div className="absolute left-0 bottom-0 h-full flex flex-col justify-between text-xs text-gray-500" data-id="element-325">
              <div data-id="element-326">High</div>
              <div data-id="element-327">Medium</div>
              <div data-id="element-328">Low</div>
              <div data-id="element-329">None</div>
            </div>
          </div>
          <div className="flex justify-around text-sm text-gray-600" data-id="element-330">
            <div data-id="element-331">Before</div>
            <div data-id="element-332">1 hour</div>
            <div data-id="element-333">3 hours</div>
            <div data-id="element-334">6 hours</div>
          </div>
          <p className="text-xs text-center text-gray-500 mt-4" data-id="element-335">
            Illustrative based on published research on topical actives;
            individual results vary.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4" data-id="element-336">
          {stats.map((stat, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-337">
              <div className="text-3xl font-bold text-[#0E6B6B] mb-2" data-id="element-338">
                {stat.percentage}%
              </div>
              <div data-id="element-339">{stat.description}</div>
            </div>)}
        </div>
      </div>
    </section>;
}